module.exports = __webpack_public_path__ + "static/media/tvshows-img1.6916c257.svg";